<template>
  <div class="box1">
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        prop="channelName"
        label="传感器"
        width="180">
      </el-table-column>
      <el-table-column
        prop="value"
        label="报警值"
        width="180">
      </el-table-column>
      <el-table-column
        prop="location"
        label="报警位置">
      </el-table-column>
      <el-table-column
        label="报警类型">
        <template slot-scope="{ row }">
          <Tag v-if="row.overType === -1" color="gold">低低报</Tag>
          <Tag v-if="row.overType === 0" color="orange">低报</Tag>
          <Tag v-if="row.overType === 1" color="warning">高报</Tag>
          <Tag v-if="row.overType === 2" color="error">高高报</Tag>
          <Tag v-if="row.overType === 3" color="success">正常</Tag>
        </template>
      </el-table-column>
      <el-table-column label="是否处理">
        <template slot-scope="{ row }">
          <Tag v-if="row.isDeal === 0" color="error">未处理</Tag>
          <Tag v-if="row.isDeal === 1" color="success">已处理</Tag>
        </template>
      </el-table-column>
      <el-table-column label="处理内容" prop="dealContent" />
      <el-table-column
        prop="level"
        label="优先级">
      </el-table-column>
      <el-table-column
        prop="gmtCreate"
        label="报警时间">
      </el-table-column>
      <el-table-column
        prop="users"
        label="通知人">
        <template slot-scope="{row}">
          {{ row.users | filter1 }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <span class="operationBtn" @click="open(scope.row.id)">处理</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="equipmentPage">
      <el-pagination
        background
        layout="prev, pager, next" @current-change="handleChange"
        :total="total" :page-size="limit" :current-page="curPage">
      </el-pagination>
    </div>

    <!-- 报警处理的弹窗 -->
    <el-dialog title="报警处理" :visible.sync="dialogFormVisible" width="25%">
      <el-form :model="form">
        <el-form-item label="报警原因" :label-width="formLabelWidth">
          <el-input v-model="form.because" size="small"></el-input>
        </el-form-item>
        <el-form-item label="处理结果" :label-width="formLabelWidth">
          <el-input v-model="form.dealContent" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitHandle" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getEquipmentAlarm, handelEquipmentAlarm } from "@/api/earlyWarning"
export default {
  name: 'equipment',
  data() {
    return {
      tableData: [],
      // 弹窗的东西
      dialogFormVisible: false,
      form: {
        because: '',
        dealContent: '',
      },
      formLabelWidth: '70px',
      total: 0,
      limit: 10,
      curPage: 1,
      handleId: '', //  存放传感器的id
    }
  },
  // 过滤器
  filters: {
    filter1(val) {
      // console.log(val)
      let arr = []
      if(val) {
        for(let i in val) {
          arr.push(val[i].nickname)
        }
      }
      return arr.join(',')
    }
  },
  methods:{
    open(id) {
      // console.log(id)
      this.dialogFormVisible = true
      this.handleId = id
    },
    getList() {
      getEquipmentAlarm({ curPage: this.curPage, limit: this.limit }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    handleChange(val) {
      this.curPage = val
      this.getList()
    },
    // 处理结果
    submitHandle() {
      if(this.form.because === '' || this.form.dealContent === ""){
        this.$message.error('处理结果或处理原因不能为空')
        return
      }
      handelEquipmentAlarm({ ...this.form, id: this.handleId }).then(res => {
        this.dialogFormVisible = false
        this.getList()
        this.form = { because: '', dealContent: '' }
      })
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>
.box1{
  width: 100%;
  padding: 0
}
  .operationBtn {
    cursor: pointer;
    color: rgb(41,140,246)
  }
  .box1 /deep/ .el-dialog__body{
    padding: 15px 20px
  }
  .box1 /deep/ .el-form-item {
    margin-bottom: 15px
  }
  .equipmentPage{
    text-align: right;
    margin-top: 15px;
  }
</style>